"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('skypeOption', {
    imNotification: null,
    callNotification: null,
});
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-skype-option/lib/data/store/store.js
// module id = 2728
// module chunks = 2 39